// extracted by mini-css-extract-plugin
export default {"error":"FileUploading_error__9j-JZ","controls":"FileUploading_controls__Dlx-g"};